var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _class, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4;

function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

/*!
 * @copyright
 * Copyright(c) 2019 SICK AG
 */
import { classMap, Component, html, Prop, CustomElement, Watch } from '@sick-davinci/ce-decorators';
import { style } from './NavigationMenuItem.style';
import { NavigationItem } from '../../navigation-item/NavigationItem';
/**
 * THIS IS NOT INTENDED TO BE USED MANUALLY BY A DEVELOPER ! ! !
 * A 'davinci-navigation-menu-item' is an item in a 'davinci-navigation-menu'.
 * It is created automatically by a 'davinci-core-navigation' as a representation of a 'davinci-core-navigation-item' inside the "more-menu".
 */

export let NavigationMenuItem = (_dec = Component({
  tag: 'davinci-navigation-menu-item',
  style,
  // tslint:disable-line:no-unsafe-any
  dependencies: []
}), _dec2 = Prop({
  type: NavigationItem,
  reflectAsAttribute: false
}), _dec3 = Reflect.metadata("design:type", Object), _dec4 = Prop({
  type: Boolean,
  reflectAsAttribute: true
}), _dec5 = Reflect.metadata("design:type", Boolean), _dec6 = Prop({
  type: Boolean,
  reflectAsAttribute: true
}), _dec7 = Reflect.metadata("design:type", Boolean), _dec8 = Prop({
  type: String,
  reflectAsAttribute: true
}), _dec9 = Reflect.metadata("design:type", Boolean), _dec10 = Watch('item'), _dec11 = Reflect.metadata("design:paramtypes", [Object, Object]), _dec(_class = (_class2 = class NavigationMenuItem extends CustomElement {
  constructor(...args) {
    super(...args);

    _initializerDefineProperty(this, "item", _descriptor, this);

    _initializerDefineProperty(this, "active", _descriptor2, this);

    _initializerDefineProperty(this, "disabled", _descriptor3, this);

    _initializerDefineProperty(this, "text", _descriptor4, this);

    this.externalRenderer = () => this.scheduleRender(true);
  }

  onItemChange(_o, newItem) {
    if (newItem) {
      this.scheduleRender(true);
      newItem.renderMenuItemCallback = this.externalRenderer;
    }
  }

  componentDisconnected() {
    if (this.item) {
      this.item.renderMenuItemCallback = undefined;
      this.item = undefined;
    }
  }

  render() {
    const classes = {
      label: true,
      active: this.item ? this.item.active : this.active,
      disabled: this.item ? this.item.disabled : this.disabled
    };
    return html`
      <div class="spacing-wrapper">
        <div class="${classMap(classes)}" @click=${this.onClick}>${this.item ? this.item.innerText : this.text}</div>
      </div>
    `;
  }

  onClick() {
    if (this.item) {
      this.item.onClick();
    }
  }

}, (_descriptor = _applyDecoratedDescriptor(_class2.prototype, "item", [_dec2, _dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "active", [_dec4, _dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "disabled", [_dec6, _dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "text", [_dec8, _dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class2.prototype, "onItemChange", [_dec10, _dec11], Object.getOwnPropertyDescriptor(_class2.prototype, "onItemChange"), _class2.prototype)), _class2)) || _class);
